import { getValueByKey } from "../../applications/Shared/Table/Utils/TableUtils";
import { CommonHelper } from "../Helpers/CommonHelper";

export function isNullOrEmpty(array: any[]): boolean {
    return array === null || array === undefined || array.length === 0;
}

export function arrayToString(array: any[], format: (ele) => any, splitBy?: string) {
    const _array = array.map((ele) => format(ele).toString());
    const _splitBy = splitBy || ", ";
    return _array.join(_splitBy);
}

export function arrayMinus(array: any[], secondArray: any[]): any[] {
    if (!secondArray || secondArray.length == 0) {return array;}
    const options = [];
    array.forEach((ele) => {
        if (!secondArray.includes(ele)) {
            options.push(ele);
        }
    });
    return options;
}

export function getUniqueValues<T>(...arrays: T[][]): T[] {
    let result = [];

    if (!arrays || !arrays.length) {
        return result;
    }

    for (let i = 0; i < arrays.length; i++) {
        const currentArray = arrays[i];
        const newElems = currentArray.filter((a) => result.every((r) => r !== a));
        result = result.concat(newElems);
    }

    return result;
}

export function contains<T>(array: T[], value: T): boolean {
    return array.indexOf(value) >= 0;
}

export function groupBy(key, array: any[]) {
    if (CommonHelper.isNullOrEmpty(key) || array.length == 0) {return {};}
    const data = {};
    array.forEach((ele) => {
        const keyValue = getValueByKey(ele, key);
        if (keyValue) {
            if (data[keyValue]) {
                data[keyValue].push(ele);
            } else {
                data[keyValue] = [ele];
            }
        }
    });
    return data;
}

export function arraysAreEqual<T>(array1: T[], array2: T[]): boolean {
    if (array1 === array2) {
        return true;
    }

    if (!array1 || !array2 || array1.length !== array2.length) {
        return false;
    }

    for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }

    return true;
}

export function getNextItem<T>(array: T[], currentValue: T): T {
    const indexOfCurrentValue = array.indexOf(currentValue);
    if (indexOfCurrentValue >= 0 && array.length > indexOfCurrentValue + 1) {
        return array[indexOfCurrentValue + 1];
    }

    return null;
}

export function getPreviousItem<T>(array: T[], currentValue: T): T {
    const indexOfCurrentValue = array.indexOf(currentValue);
    if (indexOfCurrentValue >= 1) {
        return array[indexOfCurrentValue - 1];
    }

    return null;
}

export function inArray<T>(array1: T[], array2: T[]): boolean {
    if (array1.length == 0 || array2.length == 0) {
        return false;
    }
    for (let i = 0; i < array1.length; i++) {
        if (array2.includes(array1[i])) {
            return true;
        }
    }
    return false;
}
